import PropTypes from 'prop-types';
import React from 'react';
import { getValidatedPriceInput } from 'Shared/helpers/priceHelpers';

import Input from '../Input';

const InputNumber = ({ value, onChange, placeholder, required, max, min, maxDecimals, className }) => {
	const handleInputChange = newValue => {
		const validatedInput = getValidatedPriceInput(newValue, value, { allowDecimals: maxDecimals > 0, maxDecimals });

		if (max && parseFloat(validatedInput) > max) {
			return max;
		}

		if (min && parseFloat(validatedInput) < min) {
			return min;
		}

		return validatedInput;
	};

	return (
		<Input
			className={className}
			placeholder={placeholder}
			required={required}
			type='text'
			value={value}
			onChange={newValue => onChange(handleInputChange(newValue))}
		/>
	);
};

InputNumber.propTypes = {
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	className: PropTypes.string,
	required: PropTypes.bool,
	max: PropTypes.number,
	min: PropTypes.number,
	maxDecimals: PropTypes.number
};

InputNumber.defaultProps = {
	value: 21,
	onChange: () => {},
	placeholder: null,
	className: null,
	required: false,
	max: null,
	min: null,
	maxDecimals: 0
};

export default InputNumber;
